import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export const Reveal = ({ children, delay = 0, y = 28, className, once = true }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, margin: "-80px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

const lineVariant = {
    hidden: { y: "112%" },
    show: { y: "0%", transition: { duration: 0.95, ease: [0.22, 1, 0.36, 1] } },
};

export const MaskedLines = ({ lines, className, lineClassName, delayChildren = 0.15, as: Tag = "h1" }) => (
    <motion.div
        initial="hidden"
        animate="show"
        variants={{ hidden: {}, show: { transition: { staggerChildren: 0.14, delayChildren } } }}
        className={className}
    >
        {lines.map((line, i) => (
            <div key={i} className="overflow-hidden py-[0.06em]">
                <motion.div variants={lineVariant} className={cn("will-change-transform", lineClassName)}>
                    <Tag className="m-0">{line}</Tag>
                </motion.div>
            </div>
        ))}
    </motion.div>
);

export const SectionHeading = ({ overline, title, description, dark = false, align = "left", id }) => (
    <div className={cn("max-w-3xl", align === "center" && "mx-auto text-center")} data-testid={id}>
        <Reveal>
            <p className={cn(
                "font-mono text-[11px] font-semibold uppercase tracking-[0.28em]",
                dark ? "text-flame" : "text-flame-dark"
            )}>
                {overline}
            </p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className={cn(
                "mt-4 font-display text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl",
                dark ? "text-white" : "text-omsivo-navy"
            )}>
                {title}
            </h2>
        </Reveal>
        {description && (
            <Reveal delay={0.16}>
                <p className={cn("mt-5 text-base leading-relaxed sm:text-lg", dark ? "text-white/65" : "text-slate-600")}>
                    {description}
                </p>
            </Reveal>
        )}
    </div>
);
